import type { FaireProductEntity } from "../../entity_types/product";

export const p_k63n553esk: FaireProductEntity = {
  token: "p_k63n553esk",
  type: "product",
  name: "Mahjong Mood Red Tile Game Crossbody Handbag",
  brandToken: "b_bnd9vqh91x",
  brandName: "Mary Frances Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/db9ed170a6d8ef69589ca44efce477df460093204d065770201f91d707ae56b4.jpeg",
  galleryImageUrls: [],
  priceDollars: 50,
  description:
    "Every Mary Frances piece is handmade!\n\nCalling all Mahjong fans! This Mahjong handbag combines colorful tiles, classic details, and a bold red backdrop for a look that's full of charm. Whether you're heading to your weekly game or meeting friends for lunch, this purse is always your lucky move. Removable crossbody beaded chain strap. Zipper closure.\n\n\nA NOTE ABOUT LEAD TIME: Orders ship \"as ready, up to 8 weeks\" — though most ship in just 4–5 weeks. The ship date shown when we accept your order is the latest possible date, not the actual ship date. Your order ships the moment your bags are ready. Questions? Just reach out — we're happy to help.",
  tags: [],
  msrpDollars: 125,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:36.872Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
